module.exports = __webpack_public_path__ + "static/media/icon-revisar_doc.06ae4883.svg";